import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { AUTOMATION_PLATFORM_FLOW_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
const RESULTS_PER_PAGE = 100;
export const SEARCH_WORKFLOWS = registerQuery({
  fieldName: 'searchWorkflows',
  args: ['query', 'offset', 'objectTypeId'],
  fetcher: ({
    query,
    offset,
    objectTypeId
  }) => http.post('crm-search/search', {
    data: {
      count: RESULTS_PER_PAGE,
      filterGroups: [{
        filters: [{
          operator: 'EQ',
          property: 'hs_is_deleted',
          value: false
        }, {
          operator: 'EQ',
          property: 'hs_is_external',
          value: false
        }, ...(objectTypeId ? [{
          operator: 'EQ',
          property: 'hs_object_type_id',
          value: objectTypeId
        }] : [])]
      }],
      objectTypeId: AUTOMATION_PLATFORM_FLOW_TYPE_ID,
      offset,
      query,
      requestOptions: {
        properties: ['hs_flow_id', 'hs_name', 'hs_object_type_id']
      },
      sorts: [{
        property: 'hs_name',
        order: 'ASC'
      }]
    }
  })
});